import type { Credentials } from './auth.services';
import AuthActionType from './auth.types';
import type { Role } from '../../data/tisms-api';
import type { AuthUser } from '../../api/httpTismsApi';

/** Payload assembled by the login saga after a successful API call. */
export interface AuthLoginSuccessPayload {
  role: Role;
  accessToken: string;
  refreshToken: string;
  user: AuthUser;
  /** Set when the account must choose a new password before use. */
  mustChangePassword?: boolean;
}

export const authLoginStart = (credentials: Credentials) => ({
  type: AuthActionType.AUTH_LOGIN_START,
  payload: credentials,
});
export const authLoginSuccess = (payload: AuthLoginSuccessPayload) => ({
  type: AuthActionType.AUTH_LOGIN_SUCCESS,
  payload,
});
export const authLoginFailure = (error: unknown) => ({
  type: AuthActionType.AUTH_LOGIN_FAILURE,
  payload: error,
});
export const authLoginChanged = () => ({ type: AuthActionType.AUTH_LOGIN_CHANGED });
export const authLoginReset = () => ({ type: AuthActionType.AUTH_LOGIN_RESET });
export const authLogout = () => ({ type: AuthActionType.AUTH_LOGOUT });
/** The interceptor refreshed the session; keep the persisted tokens in step. */
export const authTokensRefreshed = (payload: { accessToken: string; refreshToken: string; mustChangePassword: boolean }) => ({
  type: AuthActionType.AUTH_TOKENS_REFRESHED as typeof AuthActionType.AUTH_TOKENS_REFRESHED,
  payload,
});

export const authPasswordChanged = () => ({
  type: AuthActionType.AUTH_PASSWORD_CHANGED as typeof AuthActionType.AUTH_PASSWORD_CHANGED,
});

export type AuthAction =
  | ReturnType<typeof authLoginStart>
  | ReturnType<typeof authLoginSuccess>
  | ReturnType<typeof authLoginFailure>
  | ReturnType<typeof authLoginChanged>
  | ReturnType<typeof authLoginReset>
  | ReturnType<typeof authPasswordChanged>
  | ReturnType<typeof authTokensRefreshed>
  | ReturnType<typeof authLogout>;
